
import BucketSquare from "../../../assets/outline/BucketSquare.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function BucketSquareIcon({ className, dataTestid = "BucketSquareIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <BucketSquare data-testid={dataTestid} className={classes} {...rest} />
  );
}
